import GradientBorderRadius from "@/ui/gradient-border-radius";
import { IconComponent } from "@/ui/icon";
import { useState } from "react";

const KeyShowButton = ({ onClick }: { onClick: () => void }) => {
  const [isKeyClicked, setIsKeyClicked] = useState<boolean>(false);

  const handleCopy = () => {
    setIsKeyClicked(true);
    onClick();

    setTimeout(() => {
      setIsKeyClicked(false);
    }, 1000);
  };

  return (
    <GradientBorderRadius
      gradient="none"
      radius="circle"
      hover="r-100"
      background="black"
      active={undefined}
      className="w-[1.375rem] h-[1.375rem] flex items-center justify-center"
    >
      <button onClick={handleCopy}>
        <IconComponent
          name={isKeyClicked ? "check" : "key"}
          className={
            isKeyClicked ? "w-[0.75rem] h-[0.75rem]" : "w-[1rem] h-[1rem]"
          }
        />
      </button>
    </GradientBorderRadius>
  );
};

export default KeyShowButton;
